import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { LayoutSplashScreen } from '../../../_base';
import getMenuConfig from '../../router/MenuConfig';
import * as builder from '../../../_base/ducks/builder';
import { actions as i18nActions } from '../../../_base/ducks/i18n';
import { actions as profileActions } from '../../store/ducks/profile.duck';
import { IAppState } from '../../store/rootDuck';

const HomePage: React.FC<TPropsFromRedux> = ({
  isAuthorized,
  setMenuConfig,
  setLanguage,
}) => {
  const [menuConfig] = useState(getMenuConfig(['ROLE_ADMIN'], isAuthorized));

  useEffect(() => {
    setLanguage('en');
  }, []);

  useEffect(() => {
    setMenuConfig(menuConfig);
  }, [setMenuConfig, menuConfig]);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Outlet />
    </Suspense>
  );
};

const connector = connect(
  (state: IAppState) => ({
    isAuthorized: state.auth.user != null,
    me: state.profile.me,
  }),
  {
    fetchMe: profileActions.fetchRequest,
    editMe: profileActions.editRequest,
    setMenuConfig: builder.actions.setMenuConfig,
    setLanguage: i18nActions.setLanguage,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HomePage);
